webpackJsonp([35783957827783],{

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var emptyObject = __webpack_require__(43);
	var _invariant = __webpack_require__(1);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 296:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/android_experiments_logo_5.74322aa1.jpg";

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cover_logo.b1527b84.png";

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/crescendo_logo.f2223d59.jpg";

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hydro_one_logo.9616afec.jpg";

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pernod_ricard_logo.3c581e66.jpg";

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/scholartree_white_logo.a2db4cb9.svg";

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wmg_logo.ea31f687.jpg";

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hungermoji_logo_2.ed2c5b64.jpg";

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/jira_shot_logo.113bb323.jpg";

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uwin_books_logo.c1017d3d.jpg";

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(75);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ExperienceUnit = __webpack_require__(74);
	
	var _ExperienceUnit2 = _interopRequireDefault(_ExperienceUnit);
	
	var _d30_30_logo = __webpack_require__(480);
	
	var _d30_30_logo2 = _interopRequireDefault(_d30_30_logo);
	
	var _android_experiments_logo_ = __webpack_require__(479);
	
	var _android_experiments_logo_2 = _interopRequireDefault(_android_experiments_logo_);
	
	var _littleNomad = __webpack_require__(491);
	
	var _littleNomad2 = _interopRequireDefault(_littleNomad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AwardsSection = function (_React$Component) {
	  _inherits(AwardsSection, _React$Component);
	
	  function AwardsSection() {
	    _classCallCheck(this, AwardsSection);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  AwardsSection.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Section2.default,
	      { title: 'Awards' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _d30_30_logo2.default,
	          colour: '#000000',
	          title: 'Developer 30 Under 30',
	          link: 'https://www.canadianbusiness.com/innovation/developer-30-under-30-gallery/image/14/',
	          timeperiod: '2017',
	          subtitle: 'Recognized as one of the top 30 software developers under the age of 30 in Canada.'
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _android_experiments_logo_2.default,
	          colour: '#104B24',
	          title: 'Android Experiments Winner',
	          link: 'https://experiments.withgoogle.com/hungermoji',
	          timeperiod: '2016',
	          subtitle: _react2.default.createElement(
	            'span',
	            null,
	            'My app HungerMoji was a winner of Google\u2019s Android Experiments I/O Challenge. Featured in ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.wired.co.uk/article/best-android-apps', target: '_blank' },
	              'Wired UK'
	            ),
	            ', ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://ca.news.yahoo.com/google-android-experiments-winners-android-100647011.html', target: '_blank' },
	              'Yahoo Tech'
	            ),
	            ', ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.makeuseof.com/tag/amazing-android-experiments-best-android/', target: '_blank' },
	              'MakeUseOf'
	            )
	          )
	        })
	      )
	    );
	  };
	
	  return AwardsSection;
	}(_react2.default.Component);
	
	exports.default = AwardsSection;
	module.exports = exports['default'];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(75);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ExperienceUnit = __webpack_require__(74);
	
	var _ExperienceUnit2 = _interopRequireDefault(_ExperienceUnit);
	
	var _cover_logo = __webpack_require__(481);
	
	var _cover_logo2 = _interopRequireDefault(_cover_logo);
	
	var _crescendo_logo = __webpack_require__(482);
	
	var _crescendo_logo2 = _interopRequireDefault(_crescendo_logo);
	
	var _scholartree_white_logo = __webpack_require__(485);
	
	var _scholartree_white_logo2 = _interopRequireDefault(_scholartree_white_logo);
	
	var _sr_logo = __webpack_require__(486);
	
	var _sr_logo2 = _interopRequireDefault(_sr_logo);
	
	var _hydro_one_logo = __webpack_require__(483);
	
	var _hydro_one_logo2 = _interopRequireDefault(_hydro_one_logo);
	
	var _pernod_ricard_logo = __webpack_require__(484);
	
	var _pernod_ricard_logo2 = _interopRequireDefault(_pernod_ricard_logo);
	
	var _wmg_logo = __webpack_require__(487);
	
	var _wmg_logo2 = _interopRequireDefault(_wmg_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExperienceSection = function (_React$Component) {
	  _inherits(ExperienceSection, _React$Component);
	
	  function ExperienceSection() {
	    _classCallCheck(this, ExperienceSection);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ExperienceSection.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Section2.default,
	      { title: 'Experience' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _cover_logo2.default,
	          colour: '#FFFFFF',
	          title: 'Cover',
	          link: 'https://cover.com',
	          timeperiod: 'Jan 2020 - Present',
	          subtitle: 'Techinal Lead. Architect Golang microservices running on Kubernetes.'
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _crescendo_logo2.default,
	          colour: '#FFFFFF',
	          title: 'Crescendo',
	          link: 'https://crescendowork.com',
	          timeperiod: 'Feb 2019 - Jan 2020',
	          subtitle: 'Lead Developer. Built interactive Slack bot using Typescript, Node, GraphQL, Postgres'
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _scholartree_white_logo2.default,
	          colour: '#FFFFFF',
	          title: 'ScholarTree',
	          link: 'https://scholartree.ca',
	          timeperiod: 'Mar 2017 - Feb 2019',
	          subtitle: 'Co-founder. Built entire site using React, Redux, Apollo, Flow, GraphQL, Next.js, Node.js, Express, PostgreSQL'
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _sr_logo2.default,
	          colour: '#FFFFFF',
	          title: 'SapientRazorfish',
	          link: 'https://www.sapientrazorfish.com',
	          timeperiod: 'Mar 2014 - Feb 2017',
	          subtitle: 'Developed REST APIs for Walmart.ca with Scala + Play. Also worked on Walmart.ca\'s native Android app.'
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _hydro_one_logo2.default,
	          colour: '#FFFFFF',
	          title: 'Hydro One',
	          link: 'https://www.hydroone.com/',
	          timeperiod: 'May 2013 - Aug 2013\xA0\xA0(Co-op)',
	          subtitle: 'Developed a desktop application to track report completion using C#, WPF, NHibernate and Microsoft SQL server'
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _pernod_ricard_logo2.default,
	          colour: '#FFFFFF',
	          title: 'Pernod Ricard',
	          link: 'https://www.pernod-ricard.com',
	          timeperiod: 'Sep 2012 - Apr 2013\xA0\xA0(Co-op + Part-time)',
	          subtitle: 'Developed single-page web apps powered by Java and Google Web Toolkit backed by an Oracle database'
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _wmg_logo2.default,
	          colour: '#FFFFFF',
	          title: 'Windsor Mold Group',
	          link: 'http://www.windsormoldgroup.com/',
	          timeperiod: 'May 2011 - Sep 2012\xA0\xA0(Co-op + Part-time)',
	          subtitle: 'Developed internal web applications built on PHP, MySQL, JavaScript, jQuery'
	        })
	      )
	    );
	  };
	
	  return ExperienceSection;
	}(_react2.default.Component);
	
	exports.default = ExperienceSection;
	module.exports = exports['default'];

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(368);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExperienceUnit = function (_Component) {
	  _inherits(ExperienceUnit, _Component);
	
	  function ExperienceUnit() {
	    _classCallCheck(this, ExperienceUnit);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ExperienceUnit.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'experience-unit col-xs-12 col-sm-6 col-md-4' },
	      _react2.default.createElement(
	        'a',
	        { href: this.props.link, target: '_blank' },
	        _react2.default.createElement('div', {
	          className: 'image',
	          style: {
	            backgroundImage: 'url(' + this.props.logo + ')',
	            backgroundColor: this.props.colour
	          } })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'title bold' },
	        this.props.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'time-period' },
	        this.props.timeperiod
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'subtitle' },
	        this.props.subtitle
	      )
	    );
	  };
	
	  return ExperienceUnit;
	}(_react.Component);
	
	exports.default = ExperienceUnit;
	module.exports = exports['default'];

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(75);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ExperienceUnit = __webpack_require__(74);
	
	var _ExperienceUnit2 = _interopRequireDefault(_ExperienceUnit);
	
	var _jira_shot_logo = __webpack_require__(490);
	
	var _jira_shot_logo2 = _interopRequireDefault(_jira_shot_logo);
	
	var _hungermoji_logo_ = __webpack_require__(489);
	
	var _hungermoji_logo_2 = _interopRequireDefault(_hungermoji_logo_);
	
	var _uwin_books_logo = __webpack_require__(492);
	
	var _uwin_books_logo2 = _interopRequireDefault(_uwin_books_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectsSection = function (_React$Component) {
	  _inherits(ProjectsSection, _React$Component);
	
	  function ProjectsSection() {
	    _classCallCheck(this, ProjectsSection);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ProjectsSection.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Section2.default,
	      { title: 'Projects' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _hungermoji_logo_2.default,
	          colour: '#FFFFFF',
	          title: 'HungerMoji',
	          link: 'https://play.google.com/store/apps/details?id=com.mikeroelens.hungermoji',
	          timeperiod: '2016',
	          subtitle: _react2.default.createElement(
	            'span',
	            null,
	            'A unique game that takes place in the Android notification drawer. Winner of Google\'s Android Experiments 2016.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              'Tech:'
	            ),
	            ' Java, Android SDK'
	          )
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _jira_shot_logo2.default,
	          colour: '#302F2F',
	          title: 'JiraShot',
	          timeperiod: '2015',
	          subtitle: _react2.default.createElement(
	            'span',
	            null,
	            'JiraShot is a bug reporting tool for QA testers testing on Android. Edit and annotate bug screenshots and upload directly to Jira!',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              'Tech:'
	            ),
	            ' Java, Android SDK, OkHttp'
	          )
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _uwin_books_logo2.default,
	          colour: '#FFFFFF',
	          title: 'UWinBooks.com',
	          link: 'https://uwinbooks.com',
	          timeperiod: '2014',
	          subtitle: _react2.default.createElement(
	            'span',
	            null,
	            'Website that helped University of Windsor students find the textbooks they needed at the lowest possible price.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              'Tech:'
	            ),
	            ' PHP, MySQL, jQuery, Nginx'
	          )
	        })
	      )
	    );
	  };
	
	  return ProjectsSection;
	}(_react2.default.Component);
	
	exports.default = ProjectsSection;
	module.exports = exports['default'];

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(369);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Section = function (_Component) {
	  _inherits(Section, _Component);
	
	  function Section() {
	    _classCallCheck(this, Section);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Section.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        'h6',
	        { className: 'bold' },
	        this.props.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section-units' },
	        this.props.children
	      )
	    );
	  };
	
	  return Section;
	}(_react.Component);
	
	exports.default = Section;
	module.exports = exports['default'];

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(370);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  About.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'about' },
	      _react2.default.createElement('div', { className: 'image' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'bio' },
	        'Hi there! \uD83D\uDC4B',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'Thanks for checking out my portfolio. This is a very brief overview of the work I\'ve done. If you\'d like to hear more please drop me a line in the chat below!'
	      )
	    );
	  };
	
	  return About;
	}(_react.Component);
	
	exports.default = About;
	module.exports = exports['default'];

/***/ }),

/***/ 370:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(371);
	
	__webpack_require__(296);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Links = function (_Component) {
	  _inherits(Links, _Component);
	
	  function Links() {
	    _classCallCheck(this, Links);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Links.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'links' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'icons-list' },
	        _react2.default.createElement(
	          'li',
	          { className: 'icon' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.github.com/mikeroelens', target: '_blank' },
	            _react2.default.createElement('i', { className: 'fa fa-github' })
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'icon' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.twitter.com/mikeroelens', target: '_blank' },
	            _react2.default.createElement('i', { className: 'fa fa-twitter' })
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'icon' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.linkedin.com/in/mikeroelens', target: '_blank' },
	            _react2.default.createElement('i', { className: 'fa fa-linkedin' })
	          )
	        )
	      )
	    );
	  };
	
	  return Links;
	}(_react.Component);
	
	exports.default = Links;
	module.exports = exports['default'];

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExperienceSection = __webpack_require__(210);
	
	var _ExperienceSection2 = _interopRequireDefault(_ExperienceSection);
	
	var _ProjectsSection = __webpack_require__(211);
	
	var _ProjectsSection2 = _interopRequireDefault(_ProjectsSection);
	
	var _AwardsSection = __webpack_require__(209);
	
	var _AwardsSection2 = _interopRequireDefault(_AwardsSection);
	
	var _About = __webpack_require__(212);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Links = __webpack_require__(213);
	
	var _Links2 = _interopRequireDefault(_Links);
	
	__webpack_require__(373);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'index' },
	    _react2.default.createElement(
	      'div',
	      { className: 'main' },
	      _react2.default.createElement(
	        'h5',
	        null,
	        'Hi, I\'m ',
	        _react2.default.createElement(
	          'span',
	          { className: 'bold' },
	          'Mike Roelens'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        { className: 'bold' },
	        'Award-winning full stack developer with over 7 years experience. I\'ve built products for major ecommerce retailers, my own startup, and many fun hacks!'
	      ),
	      _react2.default.createElement(_ExperienceSection2.default, null),
	      _react2.default.createElement(_ProjectsSection2.default, null),
	      _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center', color: '#656262', marginTop: '20px' } },
	        '...I\'ve also initiated and built many internal tools/projects at companies, e.g.',
	        _react2.default.createElement(
	          'ul',
	          { style: { listStyle: 'none', marginTop: '5px' } },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              'Chrome extension'
	            ),
	            ' to monitor pre-production environments'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              'Proxy tool'
	            ),
	            ' to help trace analytics calls sent from mobile devices'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'bold' },
	              'Electron desktop app'
	            ),
	            ' to streamline support and admin tasks'
	          )
	        )
	      ),
	      _react2.default.createElement(_AwardsSection2.default, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'aside' },
	      _react2.default.createElement(
	        'div',
	        { className: 'top' },
	        _react2.default.createElement(_About2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'bottom' },
	        _react2.default.createElement(_Links2.default, null)
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-fe3bfe3856a9c76873db.js